import type { NodeViewProps } from '@tiptap/react'
import { NodeViewWrapper } from '@tiptap/react'
import { BookOpen, FileText } from 'lucide-react'
import { Link } from 'react-router'

import { cn } from '@/lib/utils'
import { bookNotePath, memoPath } from '@/routes/paths'
import { useMemoStore } from '@/store/useMemoStore'

export const DocLinkNodeView = ({ node, selected }: NodeViewProps) => {
  const targetType = node.attrs.targetType === 'product' ? 'product' : 'memo'
  const targetId = (node.attrs.targetId ?? null) as number | null
  const snapshotLabel = String(node.attrs.label ?? '')
  // メモはタイトルが変わることがあるので、読み込み済みならメモ一覧の今のタイトルを出す
  const memoTitle = useMemoStore((s) =>
    targetType === 'memo' && targetId !== null ? s.memos.find((m) => m.id === targetId)?.title : undefined,
  )
  const label = memoTitle || snapshotLabel || (targetType === 'memo' ? '無題のメモ' : '作品')
  const Icon = targetType === 'product' ? BookOpen : FileText

  return (
    <NodeViewWrapper as="span" className="doc-link-node">
      {targetId === null ? (
        <span className="text-muted-foreground">[[{label}]]</span>
      ) : (
        <Link
          to={targetType === 'product' ? bookNotePath(targetId) : memoPath(targetId)}
          contentEditable={false}
          className={cn(
            'mx-0.5 inline-flex items-baseline gap-0.5 rounded bg-blue-500/10 px-1 text-[0.95em] text-blue-600 no-underline hover:underline dark:text-blue-400',
            selected && 'outline-2 outline-(--tt-brand-color-500)',
          )}
        >
          <Icon className="size-3.5 shrink-0 self-center" />
          {label}
        </Link>
      )}
    </NodeViewWrapper>
  )
}
